import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/ui/PageHeader";
import CodManagerReports from "../codSalesManager/CodManagerReports";
import { pageShellSx } from "../codSalesRep/codStyles";

/** Standalone page: /codSalesManagerReports — per-rep report for the logged-in sales manager. */
const CodSalesManagerReportsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ ...pageShellSx, maxWidth: 1440, mx: "auto" }}>
      <PageHeader title={t("codReports.pageTitle")} />
      <CodManagerReports />
    </Box>
  );
};

export default CodSalesManagerReportsPage;
